export default __webpack_public_path__ + "static/media/facebook-logo.195cd585.svg";